module.exports = __webpack_public_path__ + "img/mean3.926fc906.png";